package org.ksdfv.thelema.img

import org.ksdfv.thelema.data.IByteData

/** @author zeganstyl */
interface IImageData {
    val sourceObject: Any
        get() = this

    var name: String

    var uri: String

    var width: Int
    var height: Int

    /** Pixel data */
    var bytes: IByteData

    var glInternalFormat: Int
    var glPixelFormat: Int
    var glType: Int

    fun destroy() {
        bytes.destroy()
    }
}